export default __webpack_public_path__ + "static/l_team_splyce_colored-5860e9a8ed82c04a51e1e2dfb04b9132.svg";